import adminApi from '../../apis/adminApi';

export function getAdminUsersService(params) {
  return adminApi.get('/api/users', { params }).then((res) => res.data);
}

export function getOneAdminUserService(id) {
  return adminApi.get(`/api/users/${id}`).then((res) => res.data);
}

export function addAdminUserService(values) {
  return adminApi.post('/api/users', values).then((res) => res.data);
}

export function updateAdminUserService(id, values) {
  return adminApi.put(`/api/users/${id}`, values).then((res) => res.data);
}

export function deleteAdminUserService(id) {
  return adminApi.delete(`/api/users/${id}`).then((res) => res.data);
}

export function recoverAdminUserService(code) {
  return adminApi.put(`/api/admin/verify/user-unblock/${code}`).then((res) => res.data);
}
